import React from "react";
import { ACTIVE_SOCIALS, SocialIcon } from "@/lib/socials";
import NewsletterForm from "@/components/NewsletterForm";

const About = () => (
    <div className="max-w-3xl mx-auto px-6 py-20" data-testid="about-page">
        <div className="text-center mb-14">
            <div className="small-caps text-xs text-muted-foreground mb-3">A quiet mission</div>
            <h1 className="font-serif text-4xl md:text-5xl">About</h1>
        </div>
        <div className="missal-card p-10 md:p-14 space-y-6 font-body leading-loose text-[15px]">
            <p className="dropcap">Hearts with Him began as a small daily habit: to open the day with the Church, to hear a prayer in a familiar voice, to see the color of the day and remember that time itself is holy.</p>
            <p>It grew into what you see now — a shared library of prayers in English, Spanish, and Latin; a friend from Scripture who walks with you; a wall of intentions carried by strangers; and a small shop of beautifully made things.</p>
            <p>Everything here is offered freely. If it becomes a grace to you, a free-will offering keeps the candles lit. If it does not, we still pray with you.</p>
            <blockquote className="border-l-2 border-liturgy pl-6 italic text-lg">“Deus meus et omnia — my God and my all.” — St. Francis</blockquote>
        </div>

        <div className="mt-14">
            <div className="divider-ornament small-caps text-xs mb-8">Walk with us</div>
            <NewsletterForm />
        </div>

        <div className="mt-14">
            <div className="divider-ornament small-caps text-xs mb-8">Follow along</div>
            <div className="flex items-center justify-center flex-wrap gap-3" data-testid="about-socials">
                {ACTIVE_SOCIALS().map(s => (
                    <a key={s.key} href={s.url} target="_blank" rel="noreferrer"
                       data-testid={`about-social-${s.key}`}
                       aria-label={s.label} title={s.label}
                       className="group flex items-center gap-2 px-4 py-3 border border-border hover:border-liturgy transition-colors">
                        <SocialIcon social={s} size={16} className="text-muted-foreground group-hover:text-current" />
                        <span className="small-caps text-xs text-muted-foreground group-hover:accent-liturgy">{s.label}</span>
                    </a>
                ))}
            </div>
        </div>
    </div>
);
export default About;
